<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
		<b-card>
			<b-row>
				<b-col cols="12">
					<app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
				</b-col>
			</b-row>
			<b-row v-if="isUploadSuccess">
				<b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Approval Configuration" active>
								<b-row class="mb-2">
									<b-col>
										<span class="float-right">
											<b-form-select v-model="approvalConfigurationPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										</span>
									</b-col>
								</b-row>
								<b-row>
								<b-col>
								<div class="table-corner">
									<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="approvalConfigurations" :fields="fieldsApprovalConfiguration" :busy="isDataLoading" :sort-by.sync="sortByApprovalConfiguration" :sort-desc.sync="sortDescApprovalConfiguration" small responsive>
									<template v-slot:head(actions)>
										<b-button @click="isShowApprovalConfigurationFilter = !isShowApprovalConfigurationFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
									</template>
									<template #top-row v-if="isShowApprovalConfigurationFilter">
										<b-th></b-th>
										<b-th stacked-heading="Name">
											<b-form-input id="input-name-table" v-model="filterApprovalConfiguration.name" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Approval Type">
											<v-select append-to-body label="name" :options="approvalTypes" :value="filterApprovalConfiguration.approvalTypeId"  :reduce="item => item.id" v-model="filterApprovalConfiguration.approvalTypeId" @search="getApprovalTypes" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Description">
											<b-form-input id="input-description-table" v-model="filterApprovalConfiguration.description" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Applied To">
											<v-select append-to-body label="name" :options="appliedTos" :value="filterApprovalConfiguration.appliedToId"  :reduce="item => item.id" v-model="filterApprovalConfiguration.appliedToId" @search="getAppliedTos" :filterable="true"></v-select>
										</b-th>
										<b-th>
										</b-th>
									</template>
									<template v-slot:table-busys>
										<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading..</strong>
										</div>
									</template>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( approvalConfigurationPageSize * (currentApprovalConfigurationPage - 1))) }}
									</template>
									<template v-slot:cell(approvalType)="row">
										{{ row.item.approvalType != null ? row.item.approvalType.name : "" }}
									</template>
									<template v-slot:cell(appliedTo)="row">
										{{ row.item.appliedTo != null ? row.item.appliedTo.name : "" }}
									</template>
									</b-table>
									</div>
								</b-col>
								<b-col cols="12">
									<b-pagination
									class="float-right btn-paging"
									v-model="currentApprovalConfigurationPage"
									:total-rows="totalApprovalConfigurationRow"
									:per-page="approvalConfigurationPageSize"
									aria-controls="my-table"
									></b-pagination>
								</b-col>
								</b-row>
							</b-tab>
							<b-tab title="Approval Configuration Detail" active>
								<b-row class="mb-2">
									<b-col>
										<span class="float-right">
											<b-form-select v-model="approvalConfigurationDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										</span>
									</b-col>
								</b-row>
								<b-row>
								<b-col>
								<div class="table-corner">
									<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="approvalConfigurationDetails" :fields="fieldsApprovalConfigurationDetail" :busy="isDataLoading" :sort-by.sync="sortByApprovalConfigurationDetail" :sort-desc.sync="sortDescApprovalConfigurationDetail" small responsive>
									<template v-slot:head(actions)>
										<b-button @click="isShowApprovalConfigurationDetailFilter = !isShowApprovalConfigurationDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
									</template>
									<template #top-row v-if="isShowApprovalConfigurationDetailFilter">
										<b-th></b-th>
										<b-th>
										</b-th>
										<b-th stacked-heading="Approver Type">
											<v-select append-to-body label="name" :options="approverTypes" :value="filterApprovalConfigurationDetail.approverTypeId"  :reduce="item => item.id" v-model="filterApprovalConfigurationDetail.approverTypeId" @search="getApproverTypes" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Approval Structure">
											<v-select append-to-body label="name" :options="approvalStructures" :value="filterApprovalConfigurationDetail.approvalStructureId"  :reduce="item => item.id" v-model="filterApprovalConfigurationDetail.approvalStructureId" @search="getApprovalStructures" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Approver Level">
											<b-form-input id="input-approver-level-table" v-model="filterApprovalConfigurationDetail.approverLevel" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Approver User Name">
											<v-select append-to-body label="firstName" :options="userInfos" :value="filterApprovalConfigurationDetail.approverUserNameUserName"  :reduce="item => item.id" v-model="filterApprovalConfigurationDetail.approverUserNameUserName" @search="getUserInfos" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Stored Procedure Name">
											<b-form-input id="input-stored-procedure-name-table" v-model="filterApprovalConfigurationDetail.storedProcedureName" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Approval Type">
											<b-form-input id="input-approval-type-table" v-model="filterApprovalConfigurationDetail.approvalType" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Configuration Content">
											<b-form-input id="input-configuration-content-table" v-model="filterApprovalConfigurationDetail.configurationContent" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Is Send Notification">
											<b-form-checkbox id="input-is-send-notification-table" @change="getApprovalConfigurationDetails" class="float-right" v-model="filterApprovalConfigurationDetail.isSendNotification"></b-form-checkbox>
										</b-th>
										<b-th>
										</b-th>
									</template>
									<template v-slot:table-busys>
										<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading..</strong>
										</div>
									</template>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( approvalConfigurationDetailPageSize * (currentApprovalConfigurationDetailPage - 1))) }}
									</template>
									<template v-slot:cell(approvalConfiguration)="row">
										{{ row.item.approvalConfiguration != null ? row.item.approvalConfiguration.name : "" }}
									</template>
									<template v-slot:cell(approverType)="row">
										{{ row.item.approverType != null ? row.item.approverType.name : "" }}
									</template>
									<template v-slot:cell(approvalStructure)="row">
										{{ row.item.approvalStructure != null ? row.item.approvalStructure.name : "" }}
									</template>
									<template v-slot:cell(approverUserName)="row">
										{{ row.item.approverUserName != null ? row.item.approverUserName.firstName : "" }}
									</template>
									</b-table>
									</div>
								</b-col>
								<b-col cols="12">
									<b-pagination
									class="float-right btn-paging"
									v-model="currentApprovalConfigurationDetailPage"
									:total-rows="totalApprovalConfigurationDetailRow"
									:per-page="approvalConfigurationDetailPageSize"
									aria-controls="my-table"
									></b-pagination>
								</b-col>
								</b-row>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-col>
			</b-row>
		</b-card>
		<template #modal-footer="{ ok, cancel }">
			<b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
				Download Log
			</b-button>
			<b-button size="sm" variant="success" class="float-right" @click="ok()">
				{{ okTitle }}
			</b-button>
			<b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
				Cancel
			</b-button>
		</template>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<style lang="scss" scoped>
.card {
	border: 1px solid rgba(0, 0, 0, 0.125) !important;
}
::v-deep.th-message {
	color: red;
}
::v-deep.modal-footer {
	display: block;
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate"; 
import { required, minLength } from "vuelidate/lib/validators"; 
import { saveAs } from 'file-saver';

import ApprovalConfiguration from '@/models/ApprovalConfiguration/ApprovalConfiguration';
import ApprovalConfigurationList from '@/models/ApprovalConfiguration/ApprovalConfigurationList';
import ApprovalConfigurationFilter from '@/filters/ApprovalConfiguration/ApprovalConfigurationFilter';

import ApprovalType from '@/models/ApprovalType/ApprovalType';
import ApprovalTypeFilter from '@/filters/ApprovalType/ApprovalTypeFilter';
import AppliedTo from '@/models/AppliedTo/AppliedTo';
import AppliedToFilter from '@/filters/AppliedTo/AppliedToFilter';
import ApprovalConfigurationDetail from '@/models/ApprovalConfiguration/ApprovalConfigurationDetail';
import ApprovalConfigurationDetailFilter from '@/filters/ApprovalConfiguration/ApprovalConfigurationDetailFilter';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
// import UserInfo from '@/models/PrivilegeManagement/UserInfo';
// import UserInfoFilter from '@/filters/PrivilegeManagement/UserInfoFilter';
import AppInputFileupload from '@/components/AppInputFileupload';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,AppInputDatetimepicker,AppInputDatetimepickerRange,},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fieldsApprovalConfiguration: [
				{"no" : { "class" : "th-number"}}, 
				{"name": { "class" : "th-name", "label" : "Name"}, key: 'name', sortable: true}, 
				{"approvalType": { "class" : "th-approval-type", "label" : "Approval Type"}, key: 'approvalType', sortable: true}, 
				{"description": { "class" : "th-description", "label" : "Description"}, key: 'description', sortable: true}, 
				{"appliedTo": { "class" : "th-applied-to", "label" : "Applied To"}, key: 'appliedTo', sortable: true}, 
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: true},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessage', sortable: true},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsApprovalConfigurationDetail: [
				{"no" : { "class" : "th-number"}}, 
				{"approvalConfiguration": { "class" : "th-approval-configuration", "label" : "ApprovalConfiguration"}, key: 'approvalConfiguration', sortable: true}, 
				{"approverType": { "class" : "th-approver-type", "label" : "Approver Type"}, key: 'approverType', sortable: true}, 
				{"approvalStructure": { "class" : "th-approval-structure", "label" : "Approval Structure"}, key: 'approvalStructure', sortable: true}, 
				{"approverLevel": { "class" : "th-approver-level", "label" : "Approver Level"}, key: 'approverLevel', sortable: true}, 
				{"approverUserName": { "class" : "th-approver-user-name", "label" : "Approver User Name"}, key: 'approverUserName', sortable: true}, 
				{"storedProcedureName": { "class" : "th-stored-procedure-name", "label" : "Stored Procedure Name"}, key: 'storedProcedureName', sortable: true}, 
				{"approvalType": { "class" : "th-approval-type", "label" : "Approval Type"}, key: 'approvalType', sortable: true}, 
				{"configurationContent": { "class" : "th-configuration-content", "label" : "Configuration Content"}, key: 'configurationContent', sortable: true}, 
				{"isSendNotification": { "class" : "th-is-send-notification", "label" : "Is Send Notification"}, key: 'isSendNotification', sortable: true}, 
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: true},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessage', sortable: true},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			busy:false,
			isDataLoading: false,
			isBusy : false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			approvalConfigurations : [],
			approvalConfigurationId : '',
			totalApprovalConfigurationRow : 0,
			isShowApprovalConfigurationFilter: false,
			filterApprovalConfiguration : null,
			currentApprovalConfigurationPage : 1,
			approvalConfigurationPageSize: 10,
			sortByApprovalConfiguration: '',
			sortDescApprovalConfiguration: '',
			filterApprovalConfigurationDetail : null,
			currentApprovalConfigurationDetailPage : 1,
			approvalConfigurationDetailPageSize: 10,
			sortByApprovalConfigurationDetail: '',
			sortDescApprovalConfigurationDetail: '',
			sortingByApprovalConfigurationDetail: [],
			approvalConfigurationDetails : [],
			approvalConfigurationDetailId : '',
			totalApprovalConfigurationDetailRow : 0,
			isShowApprovalConfigurationDetailFilter: false,
			approvalConfigurations: [],
			approverTypes: [],
			approvalStructures: [],
			userInfos: [],
			approvalTypes: [],
			appliedTos: [],
			processId: "",
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'approvalconfiguration/confirmUpload',
					[],
					).then(async function(response){
						if (response != null) {
						if (response.data != null) {
							_this.resetModal();
							_this.datas = Array();
							_this.fileupload = null;
							_this.isUploadSuccess = false;
						}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
				let data = new FormData();
				data.append('file', this.fileupload);
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'approvalconfiguration/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.isBusy = false;
						_this.isUploadSuccess = true;
						_this.getApprovalConfigurations();
						_this.getApprovalConfigurationDetails();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getApprovalConfigurations : async function() {
			let filter = {};
			Object.assign(filter, this.filterApprovalConfiguration);
			filter.draftFromUpload = "1";
			filter.draftMode = "1";
			this.sortingByApprovalConfiguration = Array();
			if (this.sortByApprovalConfiguration != null) {
				this.sortingByApprovalConfiguration[this.sortByApprovalConfiguration] = this.sortDescApprovalConfiguration;
			}
			let currentPage = (this.currentApprovalConfigurationPage - 1);
			ApprovalConfiguration.getList(this, filter, this.sortingByApprovalConfiguration, currentPage , this.approvalConfigurationPageSize).then(result => {
				this.approvalConfigurations = result.data;
				this.totalApprovalConfigurationRow = result.dataCount;
			}).catch(error => {});
		},
		getApprovalConfigurationDetails : async function() {
			let filter = {};
			Object.assign(filter, this.filterApprovalConfigurationDetail);
			filter.draftFromUpload = "1";
			filter.draftMode = "1";
			this.sortingByApprovalConfigurationDetail = Array();
			if (this.sortByApprovalConfigurationDetail != null) {
				this.sortingByApprovalConfigurationDetail[this.sortByApprovalConfigurationDetail] = this.sortDescApprovalConfigurationDetail;
			}
			let currentPage = (this.currentApprovalConfigurationDetailPage - 1);
			ApprovalConfigurationDetail.getList(this, filter, this.sortingByApprovalConfigurationDetail, currentPage , this.approvalConfigurationDetailPageSize).then(result => {
				this.approvalConfigurationDetails = result.data;
				this.totalApprovalConfigurationDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalTypes : async function(input) {
			let filter = new ApprovalTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalTypes = result.data
				}
			})
			.catch(error => {});
		},
		getAppliedTos : async function(input) {
			let filter = new AppliedToFilter();
			if (input != undefined) {
				filter.name = input;
			}
			AppliedTo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.appliedTos = result.data
				}
			})
			.catch(error => {});
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowApprovalConfigurationDetailFilter = true;
			}
		},
		downloadLog() {
			let _this = this;
			this.$http.post(process.env.VUE_APP_API_URL + 'approvalconfiguration/downloadlog', [],
			{ headers: { 'Content-Type': 'application/json' }}
			).then(async function(response){
				await saveAs(process.env.VUE_APP_API_URL + 'approvalconfiguration/downloadlog', "ApprovalConfiguration.xslx");
				_this.isBusy = false;
			})
			.catch(error => {
				_this.$store.dispatch('addErrorMessageGlobal', error);
				_this.isBusy = false;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		sortByApprovalConfiguration : {
			handler: function() {
				this.getApprovalConfigurations();
			}
		},
		sortDescApprovalConfiguration: {
			handler: function() {
				this.getApprovalConfigurations();
			}
		},
		currentApprovalConfigurationPage: {
			handler: function() {
				this.getApprovalConfigurations();
			}
		},
		approvalConfigurationPageSize : {
			handler: function() {
				this.getApprovalConfigurations();
			}
		},
		filterApprovalConfiguration: {
			handler: function() {
				this.getApprovalConfigurations();
			},
			deep: true,
		},
		sortByApprovalConfigurationDetail : {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		sortDescApprovalConfigurationDetail: {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		currentApprovalConfigurationDetailPage: {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		approvalConfigurationDetailPageSize : {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		filterApprovalConfigurationDetail: {
			handler: function() {
				this.getApprovalConfigurationDetails();
			},
			deep: true,
		},
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Proses";
				}
				return "Simpan";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterApprovalConfiguration = new ApprovalConfigurationFilter();
					this.filterApprovalConfigurationDetail = new ApprovalConfigurationDetailFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
